import { createContext } from 'react';
import type { Company } from '@/types/api';

export interface SelectedCompanyContextType {
  selectedCompany: Company | null;
  effectiveCompany: Company | null | undefined;
  selectCompany: (company: Company | null) => void;
  clearSelectedCompany: () => void;
  canSelectCompany: boolean;
  isInitialized: boolean;
  companies: Company[];
}

export const SelectedCompanyContext = createContext<SelectedCompanyContextType | undefined>(undefined);
